
import React, { useState, useEffect } from 'react';
import PlatformFeedbackForm from './PlatformFeedbackForm';

interface SurveyModalProps {
  delayMs?: number; // Késleltetés milliszekundumban a megjelenítés előtt
  dismissDays?: number; // Hány napig ne jelenjen meg újra, ha bezárták
}

const SurveyModal: React.FC<SurveyModalProps> = ({
  delayMs = 30000, // Alapértelmezetten 30 másodperc
  dismissDays = 30, // Alapértelmezetten 30 nap
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Ellenőrizzük, hogy korábban elutasította-e már a felhasználó
    const lastDismissed = localStorage.getItem('surveyDismissedAt');
    const shouldShow = !lastDismissed ||
      (new Date().getTime() - Number(lastDismissed)) > dismissDays * 24 * 60 * 60 * 1000;

    // Ha még nem utasította el, vagy már lejárt az elutasítási időszak
    if (shouldShow) {
      // Késleltetett megjelenítés
      const timer = setTimeout(() => {
        setOpen(true);
      }, delayMs);

      return () => clearTimeout(timer);
    }
  }, [delayMs, dismissDays]);

  const handleClose = () => {
    // Tároljuk, hogy mikor utasította el
    localStorage.setItem('surveyDismissedAt', new Date().getTime().toString());
    setOpen(false);
  };

  return (
    <PlatformFeedbackForm
      isOpen={open}
      onClose={handleClose}
    />
  );
};

export default SurveyModal;
